import Styled from "styled-components/macro"
import Color from "../../../constants/Color"
import { Link } from "react-router-dom"

export const Container = Styled.div`
  width: 100%;
  height: auto;
  padding: 12px 0;
  padding-bottom: 0;
  background: #18181b;
`

export const MainTitle = Styled.h2`
  margin-left: 16px;
  font-size: 20px;
  margin-bottom: 12px;
  color: ${Color.gray200};
  @media (min-width: 640px){
    margin-left: 0px;
  }
`

export const Wrapper = Styled.div`
  padding: 12px 16px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  @media (min-width: 640px){
    padding: 12px 0px;
  }

  @media (min-width: 768px){
    gap: 72px;
  }
  @media (min-width: 1028px){
    gap: 260px;
  }
  
`

export const Item = Styled.div`
  
`
export const Content = Styled.div`
  width: 100%;
  border-top: 1px solid ${Color.gray100};
  border-bottom: 2px solid ${Color.gray300};
  /* background: ${Color.gray200}; */
  background: linear-gradient(180deg, #FAFAFA 0%, #E4E4E7 100%);
`

export const Title = Styled.h4`
  font-size: 16px;
  color: ${Color.gray600};
  margin-bottom: 6px;
`
export const Text = Styled.p`
  font-size: 18px;
  color: ${Color.gray600};
`

export const SocialLink = Styled(Link)`
  display: inline-block;
  font-size: 20px;
  margin: 0 4px;

  &:last-child{
    margin-right: 0;
  }

  & i{
    color: ${Color.gray500};
  }
`

export const ItemWrapper = Styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;


  &:last-child{
    text-align: right;
  }

  & ${Item}{
    margin-bottom: 16px;
  }

  @media (min-width: 768px){
    flex-direction: row;
    

    ${Item}{
    margin-bottom: 0px;
    }

    &:last-child ${Item}:nth-child(1){
      text-align: left;
    }
  }
`
